import PageTitle from "./../layouts/PageTitle";
import BooksAcquiredList from "../components/BooksAcquired";
import MyEbooks from "../components/MyEbooks";
import { Tabs } from "antd";

export default function BooksAcquired() {
  const { TabPane } = Tabs;

  const tabItems = [
    {
      key: '1',
      label: 'Cadernos Jurídicos',
      children: <BooksAcquiredList />
    },
    {
      key: '2',
      label: 'Cadernos Essenciais',
      children: <MyEbooks />
    }
  ];

  return (
    <>
      <div className="page-content header-padding-main">
        <PageTitle parentPage="CJ" childPage="Meus Cadernos" />

        <div className="container box-main mt-5 mb-5">
          <div className="revision-intro-box">
            Aqui você baixa os seus cadernos e controla os seus estudos!
          </div>
          <Tabs
            defaultActiveKey="1"
            items={tabItems}
            size="large"
            style={{ minHeight: '400px' }}
          />
        </div>

      </div>
    </>
  );
}
